import { forwardRef } from 'react';
import { css } from '@emotion/react';

type Props = {
  children: React.ReactNode;
  id?: string;
};

export const WeavePageWrap = forwardRef<HTMLDivElement, Props>(({ children, id, ...rest }, ref) => (
  <div
    ref={ref}
    id={id}
    css={css`
      height: 100%;
      overflow-y: auto;
    `}
    {...rest}
  >
    {children}
  </div>
));

WeavePageWrap.displayName = 'WeavePageWrap';
